var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumericTransformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 7,
    viewBox: "0 0 21 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 6.5C4.65685 6.5 6 5.15685 6 3.5C6 1.84315 4.65685 0.5 3 0.5C1.34315 0.5 0 1.84315 0 3.5C0 5.15685 1.34315 6.5 3 6.5Z",
    fill: "#AECDFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 6C4.38071 6 5.5 4.88071 5.5 3.5C5.5 2.11929 4.38071 1 3 1C1.61929 1 0.5 2.11929 0.5 3.5C0.5 4.88071 1.61929 6 3 6Z",
    stroke: "#AECDFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2998 6.80078C18.9567 6.80078 20.2998 5.45764 20.2998 3.80078C20.2998 2.14393 18.9567 0.800781 17.2998 0.800781C15.643 0.800781 14.2998 2.14393 14.2998 3.80078C14.2998 5.45764 15.643 6.80078 17.2998 6.80078Z",
    fill: "#AECDFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2998 6.30078C18.6805 6.30078 19.7998 5.18149 19.7998 3.80078C19.7998 2.42007 18.6805 1.30078 17.2998 1.30078C15.9191 1.30078 14.7998 2.42007 14.7998 3.80078C14.7998 5.18149 15.9191 6.30078 17.2998 6.30078Z",
    stroke: "#AECDFC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.95461 4.92578C2.95461 5.18578 3.05461 5.36578 3.33461 5.36578C3.61461 5.36578 3.71461 5.18578 3.71461 4.92578V2.08578C3.71461 1.81578 3.58461 1.74578 3.42461 1.74578C2.99961 1.74578 3.15461 2.31578 2.59961 2.43578L2.41461 2.47578C2.15461 2.52578 2.05461 2.57578 2.05461 2.76078C2.05461 2.96578 2.14461 3.02578 2.30961 3.02578H2.95461V4.92578Z",
    fill: "#272D55"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0796 4.67078C17.1446 4.48078 17.4896 4.27578 18.0546 3.95578C18.5846 3.65578 18.8896 3.39578 18.8896 2.73078C18.8896 2.27078 18.4146 1.74578 17.6146 1.74578C16.8796 1.74578 16.2796 2.21078 16.2796 2.82078C16.2796 3.07078 16.4396 3.15578 16.6446 3.15578C16.8446 3.15578 16.9096 3.06078 16.9596 2.87578C17.0696 2.47578 17.2846 2.34578 17.6046 2.34578C17.8796 2.34578 18.1296 2.52578 18.1296 2.85078C18.1296 3.25578 17.8896 3.34578 17.1946 3.78578C16.5696 4.18078 16.2546 4.57578 16.2546 4.93078C16.2546 5.10578 16.3746 5.30078 16.6646 5.30078H18.5396C18.7696 5.30078 18.9096 5.21078 18.9096 4.98578C18.9096 4.76078 18.7696 4.67078 18.5796 4.67078H17.0796Z",
    fill: "#272D55"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.34961 3.80078H11.5876",
    stroke: "#272C55",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1494 1.80078L12.6494 3.80078",
    stroke: "#272C55",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1494 5.80078L12.6494 3.80078",
    stroke: "#272C55",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumericTransformation);
export default __webpack_public_path__ + "static/media/NumericTransformation.facf2a02b814fdf9892aeffe914ccc63.svg";
export { ForwardRef as ReactComponent };